import React from "react";
import "./customCheckBox.scss";
import { checkMarkOrange } from "../../images";

const CustomCheckBoxInput = ({ label, checked, onChange, isLigthMode }) => {
  return (
    <label className={`custom-checkbox ${isLigthMode === false && "custom_checkbox--dark-mode"}`}>
      <input
        type="checkbox"
        checked={checked}
        onChange={onChange}
        className="custom-checkbox__input"
      />
      <span className="custom-checkbox__box">
        <img
          src={checkMarkOrange}
          alt="Checked"
          className="custom-checkbox__icon"
        />
      </span>
      <span
        className={`custom-checkbox__label ${
          isLigthMode === false && "text-white"
        }`}
      >
        {label}
      </span>
      {/* <span
        className="custom-checkbox__label"
        dangerouslySetInnerHTML={{ __html: label }}
      ></span> */}
    </label>
  );
};

export default CustomCheckBoxInput;
